export const tableClass = "ux-table-data";
